var abandoned = false;

$(document).ajaxError(function( event, jqxhr, settings, thrownError ) {
	var msg, alertmsg;
	
    if(!abandoned && jqxhr.status == 401) {
        abandoned = true;
        window.location = "/api/Auth?t=" + encodeURIComponent(window.location);
    } else if(jqxhr.status == 500) {
        if(jqxhr.responseJSON) {
            if(jqxhr.responseJSON.Message) {
                alertmsg = jqxhr.responseJSON;
            }
        }
        
        if(alertmsg) {
            msg = $.parseHTML(M.templates.alert_stacktrace(alertmsg));
            $("#main").prepend(msg);
			msg[0].scrollIntoView(false);
        }
        //debugger;
    } else if(jqxhr.status < 500 && jqxhr.status >= 400) {
        if(jqxhr.responseJSON) {
            if(jqxhr.responseJSON.Message) {
                alertmsg = jqxhr.responseJSON;
            }
        }
        
        if(alertmsg) {
            msg = $.parseHTML(M.templates.alert(alertmsg));
            $("#main").prepend(msg);
			msg[0].scrollIntoView(false);
        }
	}
});


